<template>
    <footer class="bg-gray-900 text-gray-400 text-sm py-6 px-4 mt-auto text-center">
        <p>&copy; 2025 Nepal Opportunities. <a target="_blank" href="https://www.scipitutor.com/">Sci-Pi</a>.</p>
    </footer>
</template>
  
<script setup></script>
  